import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import ActivatePassphrase from '../dashboard/Passphrase/activatePassphrase'

export default function CertificateSetupPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const documentId = location.state?.documentId
  const returnTo = location.state?.fromSignature && documentId
    ? `/signature/${documentId}`
    : '/notifications'

  return (
    <ActivatePassphrase
      show={true}
      handleClose={() => navigate('/notifications')}
      redirectTo={returnTo}
    />
  )
}
